import React, { useState, useEffect } from 'react';
import { Div, CenterRowDiv } from 'styles';
import { Button, Icon, Img, InfoDiv, Input, LineText, Modal, Radio, SubTitle, Switch } from 'components';
import { useImmer } from 'use-immer';
import { Spinner } from 'components/loading/Spinner';
import { findIndex } from 'lodash';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormikInput } from 'components/form/input/FormikInput';
import useAlertContext from 'hooks/useAlertContext';
import houseActuatorService from 'services/house/house-actuator-service';

function ModalActuatorFanDetail({open, setOpen, title, id, sensorValue, afterCancel, afterSubmit}) {
  const { alert } = useAlertContext();

  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const schema = yup.object().shape({
    sensorValue: yup.number()
        .required('필수 입력항목 입니다.')
        .min(0, '입력값이 0 와 100 사이에 있어야합니다.')
        .max(100, '입력값이 0 와 100 사이에 있어야합니다.')
  });

  const handleOnSubmit = async (values) => {
    setLoading(true);

    let updateResponse = null;
    // let attempt = 0;
    const failCount = 5;
  
    try {
        let isSuccess = false;
      for(let i =0; i <failCount;i++){
        // eslint-disable-next-line no-await-in-loop
        updateResponse = await houseActuatorService.updateHouseFanSensorValue(id, values.sensorValue);
        console.log('카운트!!', i)
        if(updateResponse.error_message !== 'serial error '){
          isSuccess = true;
          break;
        }
      }
      // while (attempt < failCount) {
      //   // eslint-disable-next-line no-await-in-loop
      //   updateResponse = await houseActuatorService.updateHouseFanSensorValue(id, values.sensorValue);
      //   if(updateResponse.result !== "serial error"){
      //     break;
      //   }
      //   attempt++;
      // }
      if (!isSuccess) {
          console.error('모든 시도에서 serial error 발생');
      }
    } catch (e) {
      console.error(e);
    }

    // if (updateResponse && updateResponse.state === ' success') {
    if (updateResponse.result === 'success') {
      alert({
        type: 'alert',
        title: 'Info',
        content: '장비 제어가 정상 수행되었습니다.',
        okCallback: () => {
          setOpen(false);
      
          if (afterSubmit) {
            afterSubmit();
          }
        }
      })
    } else {
      let errorMessage = '장비 제어시 에러가 발생했습니다.';

      if (updateResponse && updateResponse.error_message) {
        errorMessage = updateResponse.error_message
      }

      alert({
        type: 'alert',
        title: 'Error',
        content: errorMessage
      })
    }

    setLoading(false);
  };
  
  const formik = useFormik({
    initialValues: {
      sensorValue: 0
    },
    validationSchema: schema,
    onSubmit: handleOnSubmit,
  });

  useEffect(() => {
    setLoading(true);
    setCanEdit(false);

    const getActuatorDetail = async () => {
      await formik.setFieldValue('sensorValue', '', true);
      await formik.resetForm();

      let data = null;

      try {
        
        data = await houseActuatorService.getHouseActuatorFanDetail(id);
        
      } catch (e) {
        console.error(e);
      }

      if (data !== null && data.length > 0) {
        await formik.setFieldValue('sensorValue', data[0].sensor_value, true);
        setCanEdit(true);
      } else {
        setCanEdit(false);
      }

      setLoading(false);
    }

    getActuatorDetail();
  }, [open])

  return (
    <Modal open={open} title={title} cancel={() => {
      setOpen(false);
      
      if (afterCancel) {
        afterCancel();
      }
    }} submit={() => {
      if (!loading && canEdit) {
        formik.submitForm();
      }
    }}>
      <form onSubmit={formik.handleSubmit}>
        <Div $flex={1}>
          <FormikInput
            type="number"
            $default
            label="장비제어조건 환기율 설정"
            name="sensorValue"
            value={formik.values.sensorValue}
            placeholder="환기율 입력"
            unit="%"
            $invalid={formik.errors.sensorValue}
            $touch={formik.touched.sensorValue}
            $invalidText={formik.errors.sensorValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Div>
        
        { loading && (
          <CenterRowDiv $justifyContent="center" $marginTop="20px">
            <Spinner $width={25} $height={25}/>
          </CenterRowDiv>
          )
        }
      </form>
    </Modal>
  )
}

export default ModalActuatorFanDetail